const settings = {
  enabled: false,
  sold: false,
  video: false,
  slideshow: false,
  tour360: false,
  gallery: false,
  details: false,
  floorplan: false,
  documents: false,
  map: false,
  walkScore: false,
  topSection: 'none',
  topSectionPhotos: [],
  numberOfPhotosOnIntro: 1,
  slideshowConfig: {
    autoplay: false,
    thumbnails: false,
    animations: false,
    fitToScreen: false,
    duration: 5000
  },
  layoutConfig: {
    primaryColor: "",
    enabled: false
  },
  music: '',
  exitPopup: false,
  leadCapture: {
    enabled: false,
    mandatory: true
  },
  openHouse: {
    enabled: false,
    days: [],
  },
  access: {
    enabled: false,
    isPublishDate: false,
    publishDate: "",
    timeZone: "",
    isTourPassword: false,
    tourPassword: "",
    tourPasswordOneTime: false,
    isMediaPassword: false,
    mediaPassword: "",
    mediaPasswordOneTime: false,
  }
};

const address = {
  address: '',
  city: '',
  country: '',
  shortStateName: '',
  longStateName: '',
  zipcode: ''
};

const videoSlideshow = {
  brandedStatus: 'none',
  unbrandedStatus: 'none',
  urlBranded: '',
  urlUnbranded: ''
};

const map = {
  lng: 0,
  lat: 0,
  zoom: 0
};

const walkScore = {
  address: '',
  enableWalkScore: true,
  enableHoodq: false,
  hoodqUrl: null,
};

const agent = {
  id: '',
  userId: '',
  agentName: '',
  agentTitle: '',
  brokerageName: '',
  avatar: [],
  logo: [],
  address: '',
  city: '',
  country: '',
  state: '',
  zipcode: '',
  email: '',
  phone: ''
};

const footer = {
  companyName: '',
  companyURL: '',
  copyrightInfo: '',
  privacyPolicy: '',
  termsAndConditions: '',
  poweredBy: true
};

const payments = {
  enabled: false,
  paid: true,
  paymentLink: null
};

const branding = {
  companyName: '',
  companyAddress: '',
  copyrightInfo: '',
  companyUrl: '',
	privacyUrl: '',
	termsUrl: '',
  adminUrl: '',
  downloadUrl: '',
  mediaUrl: '',
  statsUrl: '',
  tourUrl: '',
  supportEnabled: false,
  supportUrl: '',
  customColorScheme: false,
  color: {
    button: '',
    background: ''
  },
  customEmail: '',
  logo: '',
  favIcon: '',
  logoEmail: ''
};

export const initialState = {
  ui: {
    title: 'Real Estate Virtual Tour Hosting Platform - HomeOnTour',
    branded: false,
    spa: true,
    layout: 'rock',
    mode: 'light'
  },
  data: {
    id: '',
    settings,
    pages: [],
    fullAddress: '',
    address,
    details: {},
    video: null,
    videoSlideshow,
    tour360: null,
    photos: [],
    floorplanPhotos: [],
    floorplanFiles: [],
    documents: [],
    map,
    walkScore,
    agent,
    multiAgents: [],
    footer,
    payments,
    branding
  }
};

export const pageOrder = {
  default: {
    details: 0,
    video: 1,
    gallery: 2,
    '360-tour': 3,
    'video-slideshow': 4,
    slideshow: 5,
    floorplan: 6,
    documents: 7,
    walkScore: 8,
    map: 9,
    contact: 10
  },
  wright: {
    details: 0,
    gallery: 1,
    video: 2,
    floorplan: 3,
    '360-tour': 4,
    'video-slideshow': 5,
    slideshow: 6,
    documents: 7,
    walkScore: 8,
    map: 9,
    contact: 10
  }
};
